// ACTION CREATORS
import {
    SET_GLOBAL_LOADING,
    EMPTY_COMMON,
    SET_GLOBAL_APP_THEME,
} from "redux/actions/constants/action-types";

const initialState = {
    globalLoading: false,
    globalAppTheme: "theme1",
};

function commonReducer(state = initialState, action) {
    if (action.type === SET_GLOBAL_LOADING) {
        return {
            ...state,
            globalLoading: action.payload,
        };
    }

    if (action.type === EMPTY_COMMON) {
        return {
            ...state,
            globalLoading: false,
        };
    }

    if (action.type === SET_GLOBAL_APP_THEME) {
        return {
            ...state,
            globalAppTheme: action.payload,
        };
    }
    return state;
}

export default commonReducer;
